<template>
	<div id="JumpsellerOrders" class="jumpsellerOrders">
		<table class="table table-sm table-hover table-12">
			<thead>
				<tr class="text-center">
					<th class="text-center">ID</th>
					<th>Completado</th>
					<th>Cliente</th>
					<th>Forma de Pago</th>
					<th class="text-center">Pago</th>
					<th class="text-center">Despacho</th>
					<th class="text-right">Total</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listJumpsellerOrders" :key="index">
					<td class="text-center">{{ item.order.id }}</td>
					<td>{{ item.order.completed_at }}</td>
					<td>{{ item.order.billing_address.name + ' ' +  item.order.billing_address.surname }}</td>
					<td>{{ item.order.payment_method_name }}</td>
					<td class="text-center">{{ item.order.status }}</td>
					<td class="text-center">{{ item.order.shipment_status }}</td>
					<td class="text-right">${{ methodFormatNumber(item.order.total) }}</td>
					<td class="text-right">
                        <i class="far fa-eye pointer" @click="showDetailJumpsellerOrder(item.order)"></i>
					</td>
				</tr>
			</tbody>
		</table>


        <div class="modal fade" id="jumpsellerOrderModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content" v-if="itemJumpsellerOrder.length != 0">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">Pedido # {{ itemJumpsellerOrder.id }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-8">
                                <div class="card">
                                    <div class="card-body">
                                        <table class="table table-sm table-hover table-12">
                                            <thead>
                                                <tr>
                                                    <th>Producto</th>
                                                    <th class="text-center">Precio</th>
                                                    <th class="text-center">Subtotal</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in itemJumpsellerOrder.products" :key="index">
                                                    <td>
                                                        <img :src="item.image" style="width: 40px">
                                                        <span style="margin-left:10px;">{{ item.name }}</span>
                                                    </td>
                                                    <td class="text-right" style="vertical-align : middle;">
                                                        <div>${{ methodFormatNumber(item.price) }} x {{ item.qty }}</div>
                                                        <div v-if="item.discount!=''" class="text-danger">-${{ methodFormatNumber(item.discount) }}</div>   
                                                    </td>
                                                    <td class="text-right" style="vertical-align : middle;">
                                                        ${{ methodFormatNumber((item.price - item.discount) * item.qty) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td class="text-right" colspan="2">{{ itemJumpsellerOrder.shipping_method_name }}</td>
                                                    <td class="text-right">${{ methodFormatNumber(itemJumpsellerOrder.shipping) }}</td>
                                                </tr>
                                                <tr style="font-size: 16px;" class="bg-claro">
                                                    <td class="text-right" colspan="2" style="padding-top:10px;padding-bottom:10px;padding-right:10px;">Total</td>
                                                    <td class="text-right" style="padding-top:10px;padding-bottom:10px;padding-right:10px;">${{ methodFormatNumber(itemJumpsellerOrder.total) }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-6 border-right">
                                                <label>Dirección de envío</label>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Nombre
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.shipping_address.name }} {{ itemJumpsellerOrder.shipping_address.surname }}
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Dirección
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.shipping_address.address }}
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Ciudad - Región
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.shipping_address.region }}
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Comuna
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.shipping_address.municipality }}
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Pais
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.shipping_address.country }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6" style="padding-left:20px">
                                                <label>Dirección de facturación</label>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Nombre
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.billing_address.name }} {{ itemJumpsellerOrder.billing_address.surname }}
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Dirección
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.billing_address.address }}
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Ciudad - Región
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.billing_address.region }}
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Comuna
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.billing_address.municipality }}
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        Pais
                                                    </div>
                                                    <div class="col-6">
                                                        {{ itemJumpsellerOrder.billing_address.country }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="card">
                                   <div class="card-body">
                                       <label>Información de Orden</label>
                                       <p><i class="far fa-user"></i> <span class="margin-left5">{{ itemJumpsellerOrder.billing_address.name }} {{ itemJumpsellerOrder.billing_address.surname }}</span></p>
                                       <p><i class="far fa-envelope"></i> <span class="margin-left5">{{ itemJumpsellerOrder.customer.email }}</span></p>
                                       <p><i class="fas fa-phone"></i> <span class="margin-left5">{{ itemJumpsellerOrder.customer.phone }}</span></p>
                                       <p><i class="fas fa-globe"></i> <span class="margin-left5">{{ itemJumpsellerOrder.customer.ip }}</span></p>
                                   </div>
                                </div>

                                <div class="card">
                                   <div class="card-body">
                                       <label>Información de Pago</label>
                                       <p><i class="far fa-credit-card"></i>  <span class="margin-left5">{{ itemJumpsellerOrder.payment_method_name }}</span></p>
                                   </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#jumpsellerOrderModal" ref="jumpsellerOrderModal"></button>

        <pre v-if="itemJumpsellerOrder.length != 0">{{ itemJumpsellerOrder }}</pre>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'

export default {
	name: 'JumpsellerOrders',
	mixins: [axiosAction, errors, mixin],
	data() {
		return {
            itemJumpsellerOrder: []
		}
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Pedidos WEB')
			this.setSubTitleModule('Lista')
            this.getAllJumpsellerOrders()
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllJumpsellerOrdersResult': this.getAllJumpsellerOrdersResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
        showDetailJumpsellerOrder(item) {
            this.itemJumpsellerOrder = item
            this.$refs.jumpsellerOrderModal.click()
        }
	},
	components: {
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>